// Extrait les messages d'erreur d'une réponse API
// ({ errors: [{ errorMessage }] } ou { errors: ['message'] })
const getApiErrorMessages = (response) => {
  const errors = Array.isArray(response?.errors) ? response.errors : [];
  const messages = errors
    .map((error) => (typeof error === 'string' ? error : error?.errorMessage))
    .filter((message) => typeof message === 'string' && message.trim() !== '');
  return [...new Set(messages)];
};

export default getApiErrorMessages;
